let isMobile = false;

if(window.screen.width >= 1023){
    isMobile = false;
} else {
    isMobile = true;
}

const spotFunctions = {
    spotDiscountPrice: function(){
        let spots = Array.from( document.querySelectorAll('.product-block') );

        if(spots.length){
            spots.forEach(spot => {
                let target = spot.querySelector('.product-price.price[data-was-processed="false"]');

                let observer = new MutationObserver(function(mutations){
                    setTimeout(function(){
                        if( spot.querySelector('.product-flags .flag.discount') != null ){
                            spot.querySelector('.product-flags .flag.discount').remove();
                        }

                        let price = spot.querySelector('.price-wrapper .cmp-price-sale-price');
                        let priceOffer = spot.querySelector('.price-wrapper .cmp-price-original-price');

                        if(price && priceOffer){
                            price = parseFloat( price.textContent.split('R$ ')[1].replace(".", "").replace(",", ".") );
                            priceOffer = parseFloat( priceOffer.textContent.split('R$ ')[1].replace(".", "").replace(",", ".") );
                            let discountOffer = 100 - (  price / priceOffer ) * 100;
                            discountOffer = discountOffer.toFixed(0);

                            let discountOfferNode =  `<div class="flag discount"><span>${discountOffer}%</span></div>`;

                            spot.querySelector('.product-flags').insertAdjacentHTML('afterbegin', discountOfferNode);
                        }      
                    }, 200);
                });
                
                let config = { attributes: true, childList: true, characterData: true };
                observer.observe(target, config);
            });
        }
    },

    spotInstallmentText: function(){
        let spots = Array.from( document.querySelectorAll('.product-block') );

        if(spots.length){
            spots.forEach(spot => {
                let target = spot.querySelector('.product-price.price[data-was-processed="false"]');

                let observer = new MutationObserver(function(mutations){
                    setTimeout(function(){
                        let priceInstallmentes = spot.querySelector('.price-wrapper .cmp-price-installments p');

                        if( priceInstallmentes != null ){
                            let text = priceInstallmentes.textContent.split('sem juros')[0];

                            priceInstallmentes.textContent = text;
                        }        
                    }, 200);
                });
                
                let config = { attributes: true, childList: true, characterData: true };
                observer.observe(target, config);
            });
        }
    },

    init: function(){
        const _this = this;

        _this.spotDiscountPrice();
        _this.spotInstallmentText();
    },
}

export default spotFunctions;